import { useAppSelector } from 'src/hooks/redux';
import Title from '../common/Title';
import { Wrapper } from './Frauds.styles';
import FraudsForm from './FraudsForm/FraudsForm';
import FraudsList from './FraudsList/FraudsList';
import { RootState } from 'src/redux/RootState';
import { useState, useEffect, useCallback } from 'react';
import { getAllFraudUsers } from 'src/apis/fraudUsers';

const Frauds = () => {
    const token = useAppSelector((state: RootState) => state.User.token);
    const [fraudUsersList, setFraudUsersList] = useState([]);
    const [loading, setLoading] = useState(true);

    const getFraudUsersList = useCallback(async () => {
        setLoading(true);
        try {
            const res = await getAllFraudUsers({ token });
            setFraudUsersList(res.fraud_users?.result || []);
        } catch (error) {
            console.error("Error fetching fraud users:", error);
            setFraudUsersList([]);
        } finally {
            setLoading(false);
        }
    }, [token]);

    useEffect(() => {
        if (token) {
            getFraudUsersList();
        }
    }, [token, getFraudUsersList]);

    return (
        <Wrapper data-id="frauds-main">
            <Title>Usuarios con fraudes</Title>
            <div className="text">
                En este panel se muestran los usuarios identificados como
                posibles fraudes, con la opción de agregarlos o verificar que no
                lo son.
            </div>
            <FraudsForm getFraudUsersList={getFraudUsersList} />
            <FraudsList fraudUsersList={fraudUsersList} loading={loading} />
        </Wrapper>
    );
};

export default Frauds;
